import React from 'react';
import { i18n_begin_your_journey_to_well_being } from '@yi/i18n/phrases/i18n_begin_your_journey_to_well_being';
import { i18n_play_series_now_for_free } from '@yi/i18n/phrases/i18n_play_series_now_for_free';
import { i18n_start_your_free_trial } from '@yi/i18n/phrases/i18n_start_your_free_trial';

import { TEpisode, rememberHasPromoSeen } from '~/src/common/lean-back';
import {
  Title,
  Description,
  DetailsBody,
  WatchTrailerButton,
  PageHeader,
  PageHeadingsGroup,
} from '~/src/components/LeanBack/common-components';
import { MembershipCTA } from '~/src/components/MembershipCTA';

import { EpisodeDetails } from './EpisodeDetails';
import { EpisodeProvider, useEpisode } from './EpisodeProvider';
import { Hero } from './Hero';
import { SeriesLink } from './SeriesLink';

type Props = { episode: TEpisode };

const SeriesEpisodeBody: React.FC = () => {
  const episode = useEpisode();
  return (
    <>
      <Hero />
      <DetailsBody>
        <PageHeader>
          <PageHeadingsGroup>
            <Title>{episode.title()}</Title>
            <SeriesLink />
            <EpisodeDetails episode={episode} />
          </PageHeadingsGroup>
          <WatchTrailerButton mediaId={episode.trailerMediaId()} />
        </PageHeader>
        <MembershipCTA headingText={i18n_play_series_now_for_free} />
        <Description>{episode.description()}</Description>
        <MembershipCTA
          centeredDesktop
          headingText={i18n_begin_your_journey_to_well_being}
          headingStyle={{ textTransform: 'uppercase' }}
          buttonText={i18n_start_your_free_trial}
        />
      </DetailsBody>
    </>
  );
};

export const SeriesEpisodePage: React.FC<Props> = ({ episode: episodeDetails }) => {
  rememberHasPromoSeen();

  return (
    <EpisodeProvider episode={episodeDetails}>
      <SeriesEpisodeBody />
    </EpisodeProvider>
  );
};
